import { z } from 'zod';
import { BaseErrorSchema } from 'libs/end-to-end/src/types/errors/base-error-schema';

export const LoginError = BaseErrorSchema.extend({
  errorType: z.literal('LoginError'),
  email: z.string(),
  errorReason: z.string(),
});

export type LoginError = z.infer<typeof LoginError>;
